export default __webpack_public_path__ + "static/screenThirdSectionUk-b1537c21c58696fbb31ffa5e7d002d39.webp";